import React from 'react';
import type { ActivityViewProps } from '../../core/types/activity.types';
import type { StructuralBreakdownPayload } from '../../core/types/payloads/structural_breakdown.types';

export function StructuralBreakdownBlock({
  payload,
}: {
  payload: StructuralBreakdownPayload;
}) {
  const isSerif = payload.typography !== 'sans';

  return (
    <div className="rounded-lg bg-slate-50/90 px-4 py-3">
      {payload.title ? (
        <h3 className="mb-3 text-sm font-semibold tracking-tight text-slate-800">{payload.title}</h3>
      ) : null}
      <div className="divide-y divide-slate-200">
        {payload.lines.map((line, index) => (
          <div
            key={`${index}-${line.badge}`}
            className="flex items-center justify-between gap-4 border-b border-slate-200 py-2 last:border-b-0"
          >
            <p
              className={`flex-1 text-sm leading-relaxed text-slate-800 ${
                isSerif ? 'font-serif' : 'font-sans'
              }`}
            >
              {line.text}
            </p>
            <span className="shrink-0 rounded-md bg-slate-800 px-2 py-1 text-xs font-medium text-white">
              {line.badge}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function StructuralBreakdownView({
  payload,
}: ActivityViewProps<'structural_breakdown'>) {
  return <StructuralBreakdownBlock payload={payload} />;
}
